import React from 'react'
import PropTypes from 'prop-types'
import cx from 'classnames'

import styles from './Button.module.scss'

/**
 * Button UI component for user interaction
 */
export const Button = (props) => {
  const { variant, size, label, children, className, ...rest } = props
  return (
    <button type='button' className={cx(styles.Container, styles[variant], styles[size], className)} {...rest}>
      {label ?? children}
    </button>
  )
}

Button.propTypes = {
  /**
   * Button variant
   */
  variant: PropTypes.oneOf(['default', 'primary', 'secondary', 'danger', 'link-default', 'link-muted', 'link-danger']),
  /**
   * Button sizes
   */
  size: PropTypes.oneOf(['regular', 'sm']),
  /**
   * Button contents
   */
  label: PropTypes.string,
  /**
   * Optional click handler
   */
  onClick: PropTypes.func
}

Button.defaultProps = {
  variant: 'default',
  size: 'regular',
  onClick: undefined
}

export default Button
